import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectTo = (props) => {
    console.log("path", props.match.params.path);
    return (
        <Redirect to={"/" + decodeURIComponent(props.match.params.path)} />
    );

}

export default RedirectTo;